import { getAPIInternalBaseURL } from '../../../../NonReact/constants/ApiConstants'
import { URLConstructor } from '../../../../NonReact/utils/URLBuilder'

export enum PathParams {
    CONTENTFUL = 'contentful',
    ENTRIES = 'entries',
    CLEAR_CACHE = 'clearCache'
}

export enum QueryParams {
    CONTENT_TYPE = 'ContentType',
    TAGS = 'Tag'
}

export enum ContentTypes {
    HELP = 'helpContent',
    AKIXI_DOCUMENT = 'akixiDocument'
}

export enum HelpTagTitles {
    ENTERPRISE_GENERAL_HELP_MODAL = 'enterprise-general-help-modal',
    MAIN_MENU_REPORTING = 'main-menu-reporting',
    REPORTING_PORTAL_TOP_BAR = 'reporting-portal-top-bar',
    CONFIGURE_REPORT_BASIC_ADVANCED = 'configure-report-basic-advanced',
    CONFIGURE_REPORT_DATE_TIME = 'configure-report-date-time',
    CONFIGURE_REPORT_LOCATIONAL_FILTERING = 'configure-report-locational-filtering',
    CONFIGURE_REPORT_MISC_FILTERING = 'configure-report-misc-filtering',
    CONFIGURE_REPORT_SCHEDULING_ADVANCED = 'configure-report-scheduling-advanced',
    CONFIGURE_REPORT_DEVICE_FILTERING = 'configure-report-device-filtering',
    CONFIGURE_REPORT_CONTENT_RESTRICTION = 'configure-report-content-restriction',
    CONFIGURE_REPORT_FIELDS_CUSTOM_SETTINGS = 'configure-report-fields-custom-settings',
    CONFIGURE_REPORT_FIELDS_ADD = 'configure-report-fields-add',
    CONFIGURE_REPORT_OTHER_TAB = 'configure-report-other-tab',
    CONFIGURE_REPORT_SCHEDULING_TAB = 'configure-report-scheduling-tab',
    EASY_PROVISIONING_EMAIL = 'easy-provisioning-tool-email',
    EASY_PROVISIONING_SUB_TYPE = 'easy-provisioning-tool-subscription-type',
    TEAMS_APPSETUP = 'teams-appsetup-help-modal',
    MANAGE_QUEUE = 'manage-queue-help',
    CRM_INTEGRATION = 'crm-integration',
    TIMEZONE_MODAL = 'timezone-modal',
    SCHEDULED_EMAILS_RECIPIENTS = 'scheduled-emails-recipients'
}

export enum Tags {
    ENTERPRISE = 'enterpriseHelp',
    REPORTING_PORTAL = 'reportingPortalHelp',
    MAIN_MENU = 'mainMenu',
    CONFIGURE_REPORT = 'configureReport',
    EASY_PROVISIONING = 'easyProvisioningTool',
    CRM_INTEGRATION = 'crmIntegration',
    TELSYS_CONFIGURATION = 'telsysConfiguration',
    MANAGE_QUEUE = 'manageQueue',
    TERMS_AND_CONDITIONS = 'termsAndConditions',
    COOKIE_POLICY = 'cookiePolicy',
    PRIVACY_POLICY = 'privacyPolicy',
    BRANDING = 'branding',
    TIMEZONE = 'timezone'
}

const CONTENTFUL_ENTRIES_BASE_URL: URLConstructor = getAPIInternalBaseURL().appendPathParams(
    PathParams.CONTENTFUL,
    PathParams.ENTRIES
)

export const HELP_URL: URLConstructor = CONTENTFUL_ENTRIES_BASE_URL.appendQueryParams({
    [QueryParams.CONTENT_TYPE]: ContentTypes.HELP
})

export const AKIXI_DOCUMENT_URL: URLConstructor = CONTENTFUL_ENTRIES_BASE_URL.appendQueryParams({
    [QueryParams.CONTENT_TYPE]: ContentTypes.AKIXI_DOCUMENT
})

export const getHelpEntriesURL = (tag: Tags): URLConstructor =>
    HELP_URL.appendQueryParams({
        [QueryParams.TAGS]: tag
    })

export const getAkixiDocumentURL = (tag: Tags): URLConstructor =>
    AKIXI_DOCUMENT_URL.appendQueryParams({
        [QueryParams.TAGS]: tag
    })

export const CLEAR_CONTENTFUL_CACHE_URL: URLConstructor = CONTENTFUL_ENTRIES_BASE_URL.appendPathParams(
    PathParams.CLEAR_CACHE
)
